import { CLOSE_MODAL, CLOSE_OVERLAYS, SET_MODAL } from "./types";

const initialState = {
  modal: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_MODAL:
      return {
        ...state,
        modal: action.payload,
      };

    case CLOSE_MODAL:
      return {
        ...state,
        modal: { ...state.modal, closeModal: true, isVisible: false },
      };

    case CLOSE_OVERLAYS:
      return {
        ...state,
        modal: { ...state.modal, closeModal: true, isVisible: false },
        sheet: { ...state.sheet, closeSheet: true, isVisible: false },
        popup: { ...state.popup, closePopup: true, isVisible: false },
      };

    default:
      return state;
  }
}
export default reducer;
